import * as Yup from "yup";

const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string().email("Enter a valid email address").required("Email is required"),
});

export default ForgotPasswordSchema;
